import { cameraService } from "client-app-core";
import {
	PTZ_PRIVILEGE_INITIAL,
	PTZ_PRIVILEGE_UPDATE,
	PTZ_PRIVILEGE_STREAM_STARTED,
	PTZ_PRIVILEGE_STREAM_STOPPED,
	PTZ_PRIVILEGE_STREAM_CONTEXT_ADDED,
	PTZ_PRIVILEGE_STREAM_CONTEXT_REMOVED
} from "./actionTypes";

const initialPtzPrivilege = (cameraId, snapshot) => {
	return {
		type: PTZ_PRIVILEGE_INITIAL,
		payload: { cameraId, snapshot }
	};
};

const updatePtzPrivilege = (cameraId, snapshot) => {
	return {
		type: PTZ_PRIVILEGE_UPDATE,
		payload: { cameraId, snapshot }
	};
};

/**
 * Start (or join) a PTZ privilege stream for a camera.
 * `contextId` uniquely identifies the caller (component instance).
 */
export const startPtzPrivilegeStream = (cameraId, contextId) => {
	return (dispatch, getState) => {
		const { ptzPrivileges } = getState();
		const existing = ptzPrivileges?.streams[cameraId];

		// If there is already a subscription, just add this context
		if (existing && existing.subscription) {
			dispatch({
				type: PTZ_PRIVILEGE_STREAM_CONTEXT_ADDED,
				payload: { cameraId, contextId }
			});
			return Promise.resolve(existing.subscription);
		}

		// No subscription yet – create one
		return cameraService
			.streamPtzPrivilege(cameraId, (err, snapshot) => {
				if (err) {
					console.error("PTZ Privilege stream error:", err);
					return;
				}

				if (!snapshot) return;

				if (snapshot.initial) {
					dispatch(initialPtzPrivilege(cameraId, snapshot));
				} else {
					dispatch(updatePtzPrivilege(cameraId, snapshot));
				}
			})
			.then(subscription => {
				dispatch({
					type: PTZ_PRIVILEGE_STREAM_STARTED,
					payload: { cameraId, contextId, subscription }
				});
				return subscription;
			});
	};
};

/**
 * Leave a PTZ privilege stream for a camera.
 * Only unsubscribes when the last context leaves.
 */
export const stopPtzPrivilegeStream = (cameraId, contextId) => {
	return (dispatch, getState) => {
		const { ptzPrivileges } = getState();
		const entry = ptzPrivileges?.streams[cameraId];

		if (!entry) {
			return;
		}

		const remainingContexts = entry.contextIds.filter(id => id !== contextId);

		// If this was the last consumer → unsubscribe
		if (remainingContexts.length === 0) {
			if (entry.subscription && typeof entry.subscription.unsubscribe === "function") {
				entry.subscription.unsubscribe();
			}
			dispatch({
				type: PTZ_PRIVILEGE_STREAM_STOPPED,
				payload: { cameraId }
			});
		} else {
			dispatch({
				type: PTZ_PRIVILEGE_STREAM_CONTEXT_REMOVED,
				payload: { cameraId, contextId }
			});
		}
	};
};
